export type SubjectUserPayload = {
	readonly id: number;
	readonly firstName: string;
	readonly lastName: string;
	readonly canBeMember: boolean;
};

export type SubjectUsersFetchedPayload = {
	subjectId: number;
	users: SubjectUserPayload[];
};

export type SubjectUsersFetchedAction = {
	type: 'SUBJECT_USERS_FETCHED';
	payload: SubjectUsersFetchedPayload;
	typeKey: string;
};

export default (
	subjectId: number,
	users: SubjectUserPayload[],
	typeKey: string,
): SubjectUsersFetchedAction => ({
	type: 'SUBJECT_USERS_FETCHED',
	payload: { subjectId, users },
	typeKey,
});
